import MultiCtrlFlag from "../multi-ctrl-flag";

const enableKey = Symbol("enable");
const genericDisableKey = Symbol("GenericDisable");

class ObjRotCtrlsDisableWrapper {
    constructor(objRotCtrl, disableFlagCtrl) {
        this._objRotCtrl = objRotCtrl;
        this._disableFlagCtrl = disableFlagCtrl;
        disableFlagCtrl.set(genericDisableKey, !objRotCtrl.enabled);
    }

    get events() { return this._objRotCtrl.events; }
    get enabled() { return this[enableKey]; }
    set enabled(v) { this[enableKey] = v; this._disableFlagCtrl.set(genericDisableKey, !v); }
    get rotationMode() { return this._objRotCtrl.rotationMode; }
    set rotationMode(v) { this._objRotCtrl.rotationMode = v; }
    get object() { return this._objRotCtrl.object; }
    get target() { return this._objRotCtrl.target; }
    setObjectSelector(selectObject) { return this._objRotCtrl.setObjectSelector(selectObject); }
    setDefaultRotationGetter(getObjectDefaultRotation) { return this._objRotCtrl.setDefaultRotationGetter(getObjectDefaultRotation); }
    update() { return this._objRotCtrl.update(); }
    clearObjectRotationSpaces() { return this._objRotCtrl.clearObjectRotationSpaces(); }
    isDamping() { return this._objRotCtrl.isDamping(); }
    setPanLimits(...args) { return this._objRotCtrl.setPanLimits(...args); }
    cancelDamping() { return this._objRotCtrl.cancelDamping(); }
    setAzimuthalAngle(...args) { return this._objRotCtrl.setAzimuthalAngle(...args); }
    setPolarAngle(...args) { return this._objRotCtrl.setPolarAngle(...args); }
    get minAzimuthAngle() { return this._objRotCtrl.minAzimuthAngle; }
    set minAzimuthAngle(v) { this._objRotCtrl.minAzimuthAngle = v; }
    get maxAzimuthAngle() { return this._objRotCtrl.maxAzimuthAngle; }
    set maxAzimuthAngle(v) { this._objRotCtrl.maxAzimuthAngle = v; }
    get minDistance() { return this._objRotCtrl.minDistance; }
    set minDistance(v) { this._objRotCtrl.minDistance = v; }
    get maxDistance() { return this._objRotCtrl.maxDistance; }
    set maxDistance(v) { this._objRotCtrl.maxDistance = v; }
    get minPolarAngle() { return this._objRotCtrl.minPolarAngle; }
    set minPolarAngle(v) { this._objRotCtrl.minPolarAngle = v; }
    get maxPolarAngle() { return this._objRotCtrl.maxPolarAngle; }
    set maxPolarAngle(v) { this._objRotCtrl.maxPolarAngle = v; }
    setAutoSpin(object, enabled, speed) { return this._objRotCtrl.setAutoSpin(object, enabled, speed); }
}

export default ObjRotCtrlsDisableWrapper;
